import {
  activateOptimizer,
  deactivateOptimizer,
  describeElementVisually,
  defineInteraction,
  describePage,
  describeDataFlow,
  analyzeAccessibility,
  extractSemanticStructure,
  highlightElementRole,
  isActivated,
} from './core';

// Export all core functions
export {
  activateOptimizer,
  deactivateOptimizer,
  describeElementVisually,
  defineInteraction,
  describePage,
  describeDataFlow,
  analyzeAccessibility,
  extractSemanticStructure,
  highlightElementRole,
  isActivated,
};

// Note: React components are available via '@stdbl/wao/react'
